import React, { Component } from "react";
import { Navbar, Form, Nav } from "react-bootstrap/";
import logo from "../assets/logo/YEX.png";
import "./navbar.css";

class NavBarLogout extends Component {
  state = {};

  render() {
    return (
      <div className="container-fluid navHead">
        <Navbar bg="none" variant="dark" className="mr-auto">
          <Navbar.Brand href="/crypto/">
            <img src={logo} alt="" className="m-1" />
          </Navbar.Brand>
          <Nav className="mr-auto flex-md-row flex-column">
            <Nav.Link href="" className="links m-2">
              Exchange
            </Nav.Link>
            <Nav.Link href="" className="links m-2">
              Products
            </Nav.Link>
            <Nav.Link href="" className="links m-2">
              Prices
            </Nav.Link>
          </Nav>
          <Form inline>
            <Nav className="mr-auto flex-md-row flex-column">
              <Nav.Link href="/crypto/" className="signUp m-2">
                Log Out
              </Nav.Link>
            </Nav>
          </Form>
        </Navbar>
      </div>
    );
  }
}
export default NavBarLogout;
